// extracted by mini-css-extract-plugin
module.exports = {"note":"note--zpGm1"};